import { MetricBreakdownCard } from 'modules/campaignAnalytics/components/MetricBreakdownCard';
import { OverviewRowWithTwoEqualColumns } from 'modules/campaignAnalytics/components/Styled';
import { useLocalesQueryContext } from 'modules/campaigns/lib/contexts/LocalesQueryContext/LocalesQueryContext';
import { MetaApprovalStatusDefinition } from 'modules/graphql';
import { useMemo } from 'react';
import { CardContent } from './CardContent';
import { TabbedCardContent } from './TabbedCardContent';

export const QuickRepliesCard = () => {
  const { activeWhatsAppTemplateLocales } = useLocalesQueryContext();
  const approvedWhatsAppTemplateLocales = useMemo(
    () =>
      activeWhatsAppTemplateLocales
        ?.filter((locale) => locale.metaApprovalStatus === MetaApprovalStatusDefinition.Approved)
        .map((locale) => locale.locale),
    [activeWhatsAppTemplateLocales],
  );
  const hasApprovedWhatsAppTemplateLocales = (approvedWhatsAppTemplateLocales ?? []).length > 1;

  return (
    <OverviewRowWithTwoEqualColumns>
      <MetricBreakdownCard title="Quick replies" data-test="quick-replies-card">
        {hasApprovedWhatsAppTemplateLocales ? (
          <TabbedCardContent locales={approvedWhatsAppTemplateLocales ?? []} />
        ) : (
          <CardContent locale={(approvedWhatsAppTemplateLocales ?? [])[0]} />
        )}
      </MetricBreakdownCard>
    </OverviewRowWithTwoEqualColumns>
  );
};
